import { DataSource, Label, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutManifestMovementQuickInfo extends Layout {
    labelO: Label;
    sourceManifestMovementOrder: DataSource;
    tableOrders: Table;
    textboxDescription: Textbox;
    textboxPlannedManifestId: Textbox;
}
